
export default function InvestmentStats() {
  const stats = [
    {
      value: '$47M+',
      label: 'Total Investments',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      value: '23%',
      label: 'Average Returns',
      icon: 'ri-line-chart-line'
    },
    {
      value: '15',
      label: 'Active Projects',
      icon: 'ri-building-line'
    },
    {
      value: '850+',
      label: 'Satisfied Investors',
      icon: 'ri-group-line'
    }
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Investment Performance</h2>
          <p className="text-xl text-gray-600">Track record of successful glamping developments and strong investor returns</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-2xl text-emerald-600`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
